import React from "react";
import { Box } from "@mantine/core";
import ButtonComp from "../ButtonComponent/ButtonComp";

const GroupedButtons = ({
  parentClass,
  funcOne,
  type,
  cancelBtnClass,
  saveBtnClass,
  textOne,
  textTwo,
  outcomeNumbers,
  disabledTwo,
}) => {
  return (
    <>
      <Box className={parentClass}>
        <ButtonComp
          text={textOne}
          onClick={funcOne}
          btnClass={cancelBtnClass}
          outcomeNumbers={outcomeNumbers}
        />
        <ButtonComp
          type={type}
          text={textTwo}
          btnClass={saveBtnClass}
          isCreateNoteloading={true}
          disabled={disabledTwo}
        />
      </Box>
    </>
  );
};

export default GroupedButtons;
